import { useLocale } from "@calcom/lib/hooks/useLocale";
import { Button } from "@calcom/ui/components/button";
import { useState } from "react";
import { FindMyMeetingDialog } from "./FindMyMeetingDialog";

export function FindMyMeetingButton() {
  const { t } = useLocale();
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  return (
    <>
      <Button
        type="button"
        StartIcon="mail"
        className="w-full justify-center whitespace-normal px-4 py-[23px] text-center leading-snug"
        onClick={() => setIsDialogOpen(true)}
        data-testid="find-my-meeting-button">
        {t("find_my_meeting_button")}
      </Button>
      <FindMyMeetingDialog isOpen={isDialogOpen} onClose={() => setIsDialogOpen(false)} />
    </>
  );
}
